export const getColorProductUpdates = (color?: string | null) => {
  switch (color?.toLowerCase()) {
    case 'factorial-core':
    case 'projects':
    case 'shift-management':
    case 'time-off':
    case 'time-tracking':
    case 'workflows':
      return {
        gradientStart: 'rgb(254, 243, 226)',
        iconBackground: '#F6A61E',
      }
    case 'it-management':
    case 'expenses':
    case 'documents':
    case 'accounts-payable':
    case 'payroll':
    case 'analytics':
      return {
        gradientStart: 'rgb(233, 241, 254)',
        iconBackground: '#5596F6',
      }
    case 'trainings':
    case 'recruitment':
    case 'performance':
    case 'engagement':
      return {
        gradientStart: 'rgb(250, 231, 228)',
        iconBackground: '#E61942',
      }
    default:
      return {
        gradientStart: 'rgb(250, 231, 228)',
        iconBackground: '#E61942',
      }
  }
}
